module.exports = __webpack_public_path__ + "static/macbook-01-aafc391effa4934767e01640b5c6f56a.png";